import './em-page-gradient.scss';

export default {
  template: '<div class="em-page-gradient"></div>',
};
